import React, { useState, useEffect } from 'react';
import { get } from '../../util/request';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { userInfo } from '../../redux/slice';
import Loading from '../../components/common/loading.js';
import { useTranslation } from 'react-i18next';
import ExitBanner from '../../components/page/exitBanner/index.js';
import { Pagination } from 'antd';
import './index.scss'

export default Products; function Products() {

  const history = useHistory();
  const { t } = useTranslation();
  const user = useSelector(userInfo);
  const [productDetails, setProductDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNum, setPageNum] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [searchName, setSearchName] = useState('');
  const previewDetail = JSON.parse(sessionStorage.getItem('previewDetail'));

  const goto = (id) => {
    history.push({
      pathname: `products/${id}`
    });
  }



  useEffect(() => {
    if (user.sfUserType === 'CL' && history.location.pathname.toLowerCase().includes('preview')) {
      history.push({
        pathname: '/products'
      });
    } else if (user.sfUserType === 'IR' && history.location.pathname.toLowerCase() === '/products') {
      history.push({
        pathname: '/preview/products'
      });
    }
    projects('');
  }, []);

  useEffect(() => {
    projects(searchName);
  }, [pageNum, pageSize, window.localStorage.lang]);


  const handleSearchChange = async (value) => {
    setSearchName(value);
  }

  const handleKeyDown = async (e) => {
    if (e.keyCode === 13) {
      projects(searchName);
    }
  }

  const handleClear = async () => {
    setSearchName('');
    projects('');
  }


  const projects = async (search) => {
    setLoading(true);
    let params = {
      size: pageSize,
      page: pageNum > 0 ? pageNum - 1 : 0,
      userId: user.userId,
      accessToken: user.accessToken,
      projectName: search,
      language: window.localStorage.lang.toUpperCase()
    };

    const data = await get('/projects', params);
    if (data) {
      setProductDetails(data.content);
      setTotal(data.totalElements);
    }
    setLoading(false);
  }


  return (
    ((user.sfUserType === 'CL' && user.hasProducts) || (user.sfUserType === 'IR' && previewDetail?.hasProducts)) && <>
      {loading ? <Loading /> : null}
      <div className='product'>
        <div className='main-box'>
          <div className='row'>
            <ExitBanner isMissingProfileBannerOpen={true} isUpdateProfileButtonVisible={true} />
          </div>
          <div className="headline product-wrapper">
            <div className='col-md-4 product-title'><p>{t('Products')}</p></div>
            <div className='col-md-8 product-header'></div>
          </div>
          <div className='submit-box product-container'>
            <div className='product-search'>
              <input type='text' className='form-control' value={searchName} placeholder={t("Project Name")} onKeyDown={handleKeyDown} onChange={(e) => handleSearchChange(e.target.value)} />
              <button className='btn btn-outline-theme' onClick={() => projects(searchName)}>{t('Search')}</button>
              <span onClick={() => handleClear()}>{t('Clear')}</span>
            </div>
            {
              productDetails.length > 0 && (<>
                {
                  productDetails.map((product) => (<>
                    <div className='product-tiles row col-md-12'>
                      <div className='col-md-4 thumbnail' onClick={() => goto(product.id)}>
                        {
                          product.status !== 'AVAILABLE' ? (<>
                            <span className='thumbnail-status'>
                              {t(product.status)}
                            </span>
                            <img src={product.thumbnail} alt='' style={{ position: "relative", top: "-34px" }} />
                          </>) : product.isNew === true ? (<>
                            <span className='thumbnail-status'>
                              {t('New')}
                            </span>
                            <img src={product.thumbnail} alt='' style={{ position: "relative", top: "-34px" }} /></>) : (<><img src={product.thumbnail} alt='' /></>)
                        }
                      </div>
                      <div className='col-md-8 product-description'>
                        <div className='product-title'>
                          {product.name}
                        </div>
                        <div className='product-content' style={{overflowWrap: 'break-word' }}>
                          {product.brief}
                        </div>
                        <div className='product-goto' onClick={() => goto(product.id)}>
                          {product.address}
                        </div>
                      </div>
                    </div>
                  </>))
                }
                <div className='product-pagination'>
                  <Pagination
                    total={total}
                    showSizeChanger
                    showQuickJumper
                    pageSize={pageSize}
                    pageSizeOptions={[10, 20, 50, 100]}
                    onChange={(page, pageSize) => {
                      setPageNum(page);
                    }}
                    onShowSizeChange={(current, size) => {
                      setPageSize(size);
                    }}
                    showTotal={(total) => `${t('Total')} ${total} ${t('items')}`}
                  />
                </div>
              </>)
            }
          </div>
        </div>
      </div>
    </>)
}
